module.exports = __webpack_public_path__ + "5fbf96a4d1d2f516a0bca032a3fd6d7a.fbx";